// The ONE global host of the fee record sheet (see openFeeRecord in openSaleRecord.js): loads the order's fees exactly as the order page does (lines_only + the enriched /sales-fees read,
// mergeFees) and renders the SAME RecordKindDrawer kind 'fee' with the SAME row payload (feeRowsOf) as a fee opened from the order page. No second copy of the sheet.
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import RecordKindDrawer from '../pages/Sales/orderPage/RecordKindDrawer';
import { mergeFees, feeRowsOf } from '../pages/Sales/orderPage/orderPageExtras.mjs';
import { OPEN_FEE_RECORD } from './openSaleRecord';

const ok = (p) => p.catch(() => null);
export default function FeeRecordHost() {
  const [cur, setCur] = useState(null);   // { fee_id, row } once loaded; row.empty = 'feeLoad' when the fee could not be read
  useEffect(() => {
    let seq = 0;
    const on = async (e) => {
      const id = ++seq; const { operation_id, fee_id } = e.detail;
      const [lines, read] = await Promise.all([ok(api.getSalesOrderLines(operation_id)), ok(api.getSalesFees(operation_id))]);
      if (id !== seq) return;
      const fees = mergeFees(lines && lines.fees, read && read.sales_fees);
      const hit = Array.isArray(fees) ? feeRowsOf(fees).find(r => r.id === fee_id) : null;
      setCur({ fee_id, row: hit ? hit.drawer.row : { title: 'fee', empty: 'feeLoad' } });
    };
    window.addEventListener(OPEN_FEE_RECORD, on);
    return () => window.removeEventListener(OPEN_FEE_RECORD, on);
  }, []);
  return cur ? <RecordKindDrawer kind="fee" id={cur.fee_id} options={{ row: cur.row }} onClose={() => setCur(null)} /> : null;
}
